import { __assign } from "tslib";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Button, Stack } from "@mui/material";
import { AuthPasswordField, PangeaModal } from "@pangeacyber/react-mui-shared";
import { useBreakpoint } from "../../utils";
var PasswordConfirmationModal = function (_a) {
    var open = _a.open, onClose = _a.onClose, title = _a.title, description = _a.description, onContinue = _a.onContinue;
    var isSmall = useBreakpoint("sm");
    var _b = useState(""), name = _b[0], setName = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var handleClose = function () {
        setName("");
        onClose();
    };
    useEffect(function () {
        setName("");
    }, [open]);
    return (_jsx(_Fragment, { children: _jsx(PangeaModal, { open: open, onClose: handleClose, title: title, description: description, size: "small", children: _jsxs(Stack, { spacing: 2, children: [_jsx(AuthPasswordField, { name: "confirm-password", label: "Continue by entering the password below", value: name, onValueChange: setName, FieldProps: {
                            type: "passwordWithPolicy",
                            policy: undefined,
                            InputProps: {
                                fullWidth: true,
                            },
                        } }), _jsxs(Stack, { direction: { xs: "column", sm: "row" }, spacing: 1, marginLeft: "auto", alignSelf: "end", sx: __assign({}, (isSmall && {
                            width: "100%",
                            paddingTop: 1,
                            button: {
                                width: "100%",
                            },
                        })), children: [_jsx(Button, { variant: "contained", onClick: handleClose, color: "secondary", children: "Cancel" }), _jsx(Button, { id: "confirm-modal-btn", variant: "contained", color: "primary", disabled: loading, onClick: function (event) {
                                    event.stopPropagation();
                                    event.preventDefault();
                                    setLoading(true);
                                    onContinue(name)
                                        .then(function (isValid) {
                                        if (isValid === undefined || isValid)
                                            onClose();
                                        setLoading(false);
                                    })
                                        .catch(function (err) {
                                        setLoading(false);
                                    });
                                }, children: "Continue" })] })] }) }) }));
};
export default PasswordConfirmationModal;
